<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10,3C9.45,3,9,3.45,9,4C9,4,9,6.59,9,6.59C9,6.59,5.71,3.29,5.71,3.29C5.53,3.11,5.28,3,5,3C4.45,3,4,3.45,4,4C4,4.28,4.11,4.53,4.29,4.71C4.29,4.71,7.59,8,7.59,8C7.59,8,4.3,11.29,4.3,11.29C4.11,11.47,4,11.72,4,12C4,12.55,4.45,13,5,13C5.28,13,5.53,12.89,5.71,12.71C5.71,12.71,9,9.41,9,9.41C9,9.41,9,12,9,12C9,12.55,9.45,13,10,13C10.55,13,11,12.55,11,12C11,12,11,4,11,4C11,3.45,10.55,3,10,3C10,3,10,3,10,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ChevronForward',
} as DefineComponent
</script>
